export const ADD_LAYER = "ADD_LAYER";
export const ADJUST_LAYERS = "ADJUST_LAYERS";
export const BUMP_LAYERS = "BUMP_LAYERS";
export const COPY_LAYERS = "COPY_LAYERS";
export const DELETE_LAYERS = "DELETE_LAYERS";
export const DESELECT_LAYERS = "DESELECT_LAYERS";
export const DRAG_LAYERS = "DRAG_LAYERS";
export const ENABLE_TEXT_EDITOR = "ENABLE_TEXT_EDITOR";
export const HIGHLIGHT_LAYER = "HIGHLIGHT_LAYER";
export const MOVE_LAYERS = "MOVE_LAYERS";
export const PASTE_LAYERS = "PASTE_LAYERS";
export const ROTATE_LAYER = "ROTATE_LAYER";
export const SCALE_LAYER = "SCALE_LAYER";
export const SELECT_LAYER = "SELECT_LAYER";
export const TOGGLE_IMAGE_PICKER = "TOGGLE_IMAGE_PICKER";
export const UNDO_ACTION = "UNDO_ACTION";
export const UPDATE_TEXT = "UPDATE_TEXT";



// WEBPACK FOOTER //
// ./src/store/constants.js